export const MAX_FIELDS: number = 50;
